<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <b-form-group
          label="Ekipman Adı"
          label-for="studioEquipmentTitle"
        >
          <b-input-group>
            <b-form-input
              id="studioEquipmentTitle"
              v-model="equipmentTitle"
              placeholder="Örn: Sony A7S III Kamera"
              @keyup.enter="addEquipment"
            />
            <b-input-group-append>
              <b-button
                variant="primary"
                :disabled="!equipmentTitle || submitStatus"
                @click="addEquipment"
              >
                Ekle
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        v-for="item in filteredEquipmentList"
        :key="item.id"
        cols="12"
        md="6"
        class="mb-1"
      >
        <b-list-group>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <div>
              <div class="font-weight-bold">
                {{ item.title || '-' }}
              </div>
              <small class="text-muted">#{{ item.id }}</small>
            </div>
            <b-button
              variant="flat-danger"
              size="sm"
              :disabled="submitStatus"
              @click="removeEquipment(item.id)"
            >
              <FeatherIcon icon="TrashIcon" class="mr-50" />
              Sil
            </b-button>
          </b-list-group-item>
        </b-list-group>
      </b-col>

      <b-col
        v-if="!filteredEquipmentList.length"
        cols="12"
      >
        <b-list-group>
          <b-list-group-item class="text-center text-muted">
            Ekipman kaydı bulunmuyor.
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'StudioEquipment',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BListGroup,
    BListGroupItem,
  },
  data() {
    return {
      equipmentTitle: null,
      submitStatus: false,
      studioId: 1,
    }
  },
  computed: {
    equipmentList() {
      const raw = this.$store.getters['studioEquipment/dataList']
      if (Array.isArray(raw)) return raw
      if (raw && Array.isArray(raw.data)) return raw.data
      if (raw && typeof raw === 'object' && raw.id) return [raw]
      return []
    },
    filteredEquipmentList() {
      return this.equipmentList.filter(item => Number(item.id_studio) === this.studioId)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('studioEquipment/getDataList', {})
    },
    addEquipment() {
      const title = (this.equipmentTitle || '').trim()
      if (!title) return

      this.submitStatus = true
      this.$store.dispatch('studioEquipment/saveData', {
        title,
        id_studio: this.studioId,
      })
        .then(() => {
          this.equipmentTitle = null
          this.getDataList()
          this.showToast({
            variant: 'success',
            title: 'İşlem Başarılı!',
            icon: 'CheckIcon',
            text: 'Ekipman eklendi.',
          })
        })
        .finally(() => {
          this.submitStatus = false
        })
    },
    removeEquipment(id) {
      this.submitStatus = true
      this.$store.dispatch('studioEquipment/removeData', id)
        .then(() => {
          this.getDataList()
          this.showToast({
            variant: 'success',
            title: 'İşlem Başarılı!',
            icon: 'CheckIcon',
            text: 'Ekipman silindi.',
          })
        })
        .finally(() => {
          this.submitStatus = false
        })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
